import useRouter from "hooks/useRouter";
import VoucherPartnerDetailView from "../../components/VoucherPartnerDetailView";
import UIHelper from "general/helpers/UIHelper";

VoucherPartnerDetailScreen.propTypes = {};

function VoucherPartnerDetailScreen(props) {
    // MARK: ---- PROPERTIES ----
    const { isVoucherPartnerInfo = false } = props;
    const router = useRouter();

    return (
        <div>
            {/* breadcrumb */}
            {!isVoucherPartnerInfo && (
                <div>
                    {UIHelper.buildBreadcrumb([
                        {
                            title: `Danh sách đối tác mua voucher`,
                            onPress: () => {
                                router.navigate(-1);
                            },
                        },
                        { title: 'Chi tiết đối tác mua voucher' },
                    ])}
                </div>
            )}
            <div className="my-4">
                <VoucherPartnerDetailView isVoucherPartnerInfo={isVoucherPartnerInfo} />
            </div>
        </div>
    );
}

export default VoucherPartnerDetailScreen;
